export default () => ({
  container: {
    padding: 24,
    height: "calc(100% - 48px)",
  },
});
